import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePickerWrapper, InputErrorMessage } from './YearPickerStyle';
import { DatePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';

interface YearPickerProps {
  label: string;
  handleChange?: (year: number | null) => void;
  // eslint-disable-next-line react/boolean-prop-naming
  error: boolean;
  helperText?: string;
  field?: any;
  minDate?: any;
  value?: any;
  sx?: object;
}

export default function YearPicker(props: YearPickerProps): React.ReactElement {
  const {
    label,
    error,
    helperText,
    field,
    handleChange,
    minDate,
    // value = null,
    sx = {}
  } = props;

  // Ensure that value is always a valid Day.js object
  const getValue = () => {
    if (typeof field?.value === 'number') {
      return dayjs().year(field.value); // Convert the year number into a dayjs object
    } else if (dayjs(field?.value).isValid()) {
      return dayjs(field.value);
    }
    return null;
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DatePickerWrapper>
        <DatePicker
          label={label}
          views={['year']}
          disableFuture
          minDate={minDate}
          defaultValue={null}
          {...field}
          value={getValue()} // Always provide a valid Day.js object
          onChange={(date: any) => {
            const yearValue = date ? dayjs(date).year() : null; // Extract only the year
            field.onChange(yearValue); // Send only the year as a number
            if (handleChange) handleChange(yearValue); // Pass only year to parent function
          }}
          format="YYYY"
          renderInput={(params: any) => (
            <TextField
              placeholder="Select Year"
              {...params}
              inputProps={{
                ...params.inputProps,
                placeholder: 'Select Year'
              }}
            />
          )}
          sx={{
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#0000003b',
              borderWidth: '1.8px'
            },
            ...sx
          }}
        />
      </DatePickerWrapper>
      {error && <InputErrorMessage>{helperText}</InputErrorMessage>}
    </LocalizationProvider>
  );
}